"use client";

import {useSession} from "next-auth/react";
import {Suspense} from "react";

import {redirect} from "next/navigation";

import Loading from "@/app/loading";
import OxcgrtDataClient from "@/components/oxcgrt-data-client";

export default function LasiDadDownloadClient() {
  const {data: session, status} = useSession();

  if (status === "loading") return <Loading />;
  if (!session) {
    redirect("/auth/sign-in");
  }

  return (
    <Suspense fallback={<Loading />}>
      <OxcgrtDataClient />
    </Suspense>
  );
}
